import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import storageService from "~/utils/storage";
import useRepository from "~/common/hooks/useRepository";
import { USER_INFO } from "~/store/user/repository";

const AuthRouter = () => {
	const location = useLocation();
	const [getUserInfo] = useRepository(USER_INFO);

	const token = storageService.get("auth", "accessToken", "local");

	let hasToken = token !== undefined;

	useEffect(() => {
		if (!hasToken) return;
		getUserInfo();
	}, [hasToken, location]);

	return <></>;
};

export default AuthRouter;
